import { useEffect } from 'react';
import { TypeFilter } from './TypeFilter';
import { SearchInput } from './SearchInput';
import { AuthorSelect } from './AuthorSelect';
import { MediaCheckbox } from './MediaCheckbox';
import { ResetButton } from './ResetButton';
import { TopAuthors } from './TopAuthors';

interface FiltersProps {
  filters: {
    type: 'all' | 'likes' | 'bookmarks';
    search: string;
    author: string;
    hasMedia: boolean;
  };
  updateFilters: (filters: Partial<{ type: 'all' | 'likes' | 'bookmarks'; search: string; author: string; hasMedia: boolean }>) => void;
  resetFilters: () => void;
}

export function Filters({ filters, updateFilters, resetFilters }: FiltersProps) {
  // Handle top author click event
  useEffect(() => {
    const handleTopAuthorClick = (e: Event) => {
      const customEvent = e as CustomEvent<string>;
      updateFilters({ author: customEvent.detail });
    };

    window.addEventListener('topAuthorClick', handleTopAuthorClick);
    return () => {
      window.removeEventListener('topAuthorClick', handleTopAuthorClick);
    };
  }, [updateFilters]);

  return (
    <aside className="filters bg-bg-secondary border border-border rounded-xl p-5 mb-5">
      <TypeFilter
        currentType={filters.type}
        onChange={(type) => {
          updateFilters({ type });
        }}
      />

      <SearchInput
        value={filters.search}
        onChange={(search) => {
          updateFilters({ search });
        }}
      />

      <AuthorSelect
        value={filters.author}
        onChange={(author) => {
          updateFilters({ author });
        }}
      />

      <MediaCheckbox
        checked={filters.hasMedia}
        onChange={(hasMedia) => {
          updateFilters({ hasMedia });
        }}
      />

      <ResetButton
        onReset={() => {
          resetFilters();
        }}
      />

      <TopAuthors />
    </aside>
  );
}
